"use client";

import { analyticEvents, handlePostAnalytics } from "@/apiUtils/analyticsUtils";
import { analyticEventTypes } from "@/apiUtils/constants";
import { commonValidationConstants } from "@/apiUtils/validationConstants";
import Button from "@/components/ui/button/Button";
import TextField from "@/components/ui/textField/TextField";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Feedback from "./Feedback";

interface IProps {
  translations: Record<string, string> | undefined;
  lang: string;
}

type FormInputs = {
  email: string;
};

const Newsletter = ({ translations, lang }: IProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>();

  const [alert, setAlert] = useState<boolean>(false);

  const { IS_MAIL } = commonValidationConstants;

  const onSubmit = (data: FormInputs) => {
    handlePostAnalytics({
      eventType: analyticEventTypes.CUSTOM,
      data: {
        target: analyticEvents.NEWSLETTER_SUBSCRIPTION,
        email: data.email,
      },
    });
    setAlert(true);
    setTimeout(() => setAlert(false), 2500);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {alert ? (
        <div
          className="mt-2 flex justify-center bg-tertiary-1 p-3 text-sm md:justify-start"
          role="alert"
        >
          {translations?.footer_newsletter_description_success_message || ""}
        </div>
      ) : (
        ""
      )}
      <div className="mt-[14px] flex flex-col items-center md:flex-row md:gap-4">
        <TextField
          variant="outlined"
          placeholder={translations?.footer_email_label || ""}
          className="bg-white placeholder:text-sm placeholder:font-normal md:max-w-[17.875rem]"
          {...register("email", {
            required: translations?.common_invalid_email_error_message || "",
            pattern: {
              value: IS_MAIL,
              message: translations?.common_invalid_email_error_message || "",
            },
          })}
        />
        <Button
          type="submit"
          className="mt-4 flex h-[2.5rem] w-full max-w-[9rem] items-center justify-center text-sm font-semibold md:mt-0 md:h-[3.125rem]"
        >
          {lang === "ar" ? "يشترك" : "Subscribe"}
        </Button>
      </div>
      <Feedback {...errors?.email} />
    </form>
  );
};

export default Newsletter;
